import React from 'react';
import PropTypes from 'prop-types';
import { CustomerContext } from './CustomerContext';

export const CustomerProvider = ({ children }) => {
  const isServer = !(
    typeof window !== 'undefined'
    && window.document
    && window.document.createElement);

  const persistedCustomerInformationContext = {
    membershipInformation: null,
  };

  /**
   * On page load, we attempt to get the values from local storage first and set context.
   *
   * If we have them, we can pass them down to the consumer (the useMembershipInformation hook).
   *
   * If we don't have them, we'll pass down the default null values and let the consumer...
   *
   * TODO: have consuming child update membershipInformation when call to Loyalty is made^
   */
  if (!isServer) {
    persistedCustomerInformationContext.membershipInformation = window.THDCustomer?.default?.membershipInformation;

    // TODO: Add LIFE_CYCLE_EVENT_BUS for logging - if needed at future time.
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('customer-context.ready', persistedCustomerInformationContext);
  }

  return (
    <CustomerContext.Provider value={persistedCustomerInformationContext}>
      {children}
    </CustomerContext.Provider>
  );
};

CustomerProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

CustomerProvider.defaultProps = {
  children: null,
};